import React, {useState} from "react";
import {useEdits} from "../../contexts/edits";
import cn from "classnames";
// Reuse BgSelector styles for the upload button look
import "../BgSelector/index.css";
import { EXAMPLE_DATA_LINK } from "data/constants";

// Simple RFC4180-ish CSV parser that supports quoted fields and commas inside quotes
function parseCSV(text) {
  const rows = [];
  let cur = '';
  let inQuotes = false;
  let row = [];
  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    if (ch === '"') {
      if (inQuotes && text[i + 1] === '"') {
        cur += '"';
        i++; // skip escaped quote
      } else {
        inQuotes = !inQuotes;
      }
    } else if (ch === ',' && !inQuotes) {
      row.push(cur);
      cur = '';
    } else if ((ch === '\n' || ch === '\r') && !inQuotes) {
      if (cur !== '' || row.length > 0) {
        row.push(cur);
        rows.push(row);
        row = [];
        cur = '';
      }
      // consume \r\n as single newline
      if (ch === '\r' && text[i + 1] === '\n') i++;
    } else {
      cur += ch;
    }
  }
  if (cur !== '' || row.length > 0) {
    row.push(cur);
    rows.push(row);
  }
  // Trim BOM from first cell if present
  if (rows.length && rows[0][0]) rows[0][0] = rows[0][0].replace(/^\uFEFF/, '');
  return rows;
}

function normalizeKey(k) {
  return (k || '').toString().trim().toLowerCase();
}

const DataSelector = () => {
  const {loadDataRows, clearDataRows, dataRows} = useEdits();
  const [error, setError] = useState('');

  const onUpload = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    if (!file.name.toLowerCase().endsWith('.csv')) {
      setError('Please select a .csv file');
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const text = reader.result || '';
        const raw = parseCSV(String(text));
        if (raw.length < 2) {
          loadDataRows([]);
          return;
        }
        const headers = raw[0].map(normalizeKey);
        const rows = raw.slice(1)
          .filter((r) => r.some((cell) => (cell || '').trim() !== ''))
          .map((r) => {
            const obj = {};
            headers.forEach((h, idx) => {
              obj[h] = (r[idx] ?? '').toString();
            });
            return obj;
          });
        loadDataRows(rows);
        setError('');
      } catch (e) {
        console.error(e);
        setError('Failed to parse CSV');
      }
    };
    reader.readAsText(file);
  };

  const exampleHref = EXAMPLE_DATA_LINK;
  const downloadable = (exampleHref || '').toLowerCase().endsWith('.csv');

  return (
    <div className="bg-selector" style={{marginTop: 8}}>
      <div>
        <input
          type="file"
          accept=".csv,text/csv"
          onChange={onUpload}
          style={{display: 'none'}}
          id="data-upload-button"
        />
        <label htmlFor="data-upload-button" className={cn('bg-button', 'upload-button')}>
          <span>Upload File</span>
        </label>
      </div>
      <div style={{marginLeft: 8, alignSelf: 'center', display: 'flex', gap: 48, alignItems: 'center'}}>
        {error ? (
          <span style={{color: '#ff7676'}}>{error}</span>
        ) : (
          <span style={{opacity: 0.8, width: "100px", fontStyle: "normal", fontSize: "1em"}}>{dataRows?.length ? `${dataRows.length} rows loaded` : 'No data loaded'}</span>
        )}
        <a href={exampleHref} style={{color: '#fff', opacity: 0.8, fontStyle: "normal", fontSize: "0.7em"}} download={downloadable} target="_blank" rel="noopener noreferrer" id="example_data_link">Example.csv</a>
      </div>
    </div>
  );
};

export default DataSelector;
